module.exports = __webpack_public_path__ + "static/top_pc-e07eb4175009ea90a88ad6af95d84e17.jpg";